import { render, staticRenderFns } from "./EnamadLegal.vue?vue&type=template&id=9d414f82"
import script from "./EnamadLegal.vue?vue&type=script&lang=js"
export * from "./EnamadLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports